/** Resposta de POST /authorized-devices/authorize-current (API #552). */
export interface AuthorizeCurrentDevicePayload {
  device?: { id?: string };
  deviceId?: string;
}

/** API retorna `deviceId` plano; versões antigas do front esperavam `device.id`. */
export function resolveAuthorizeCurrentDeviceId(
  data: AuthorizeCurrentDevicePayload
): string | undefined {
  const id = data.device?.id ?? data.deviceId;
  if (!id || String(id).trim() === '') return undefined;
  return String(id).trim();
}
